export * from './lib/UiProductInfoMain';
export * from './mock';
